module.exports = __webpack_public_path__ + "img/no-docs-selected.d70626f2.svg";